module.exports = __webpack_public_path__ + "static/media/BT.2155d6ff.svg";